import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";

export default function SummerPage() {
  return (
    <div className="bg-white font-saol">
      {/* Section: Title */}
      <div className="mt-24 mb-14 flex items-center justify-center px-6">
        <h1 className="text-black text-4xl md:text-7xl lg:text-[90px] leading-tight md:leading-[1.2] tracking-tight whitespace-pre-line text-center">
          {`LIVE WONDROUS MOMENTS\nOF JOY. FIND YOUR\nNEVER-ENDING SUMMER\nAT NAMMOS WORLD.`}
        </h1>
      </div>

      {/* Footer */}
      <footer className="border-t border-gray-300 px-6 md:px-20 py-12 text-black font-serif">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left">
          {/* Left Links */}
          <div className="space-y-2 text-sm">
            <p>NAMMOS WORLD</p>
            <p>NAMMOS MYKONOS</p>
            <p>NAMMOS VILLAGE</p>
            <p>NAMMOS DUBAI</p>
            <p>NAMMOS CANNES</p>
            <p>NAMMOS LIMASSOL</p>
            <p>NAMMOS SARDINIA</p>
          </div>

          {/* Center - Newsletter */}
          <div className="flex flex-col items-center">
            <img
              src="/f.jpg"
              alt="logo"
              className="w-16 h-16 rounded-full object-cover mb-4"
            />
            <h3 className="text-base font-semibold mb-3">NEWSLETTER</h3>
            <div className="flex items-center border-b border-black w-full max-w-xs justify-between">
              <input
                type="email"
                placeholder="Your email here"
                className="w-full bg-transparent p-1 text-sm outline-none"
              />
              <button className="text-sm font-semibold">OK</button>
            </div>

            {/* Social Icons */}
            <div className="flex space-x-4 mt-4">
              <a href="#" aria-label="Facebook"><FaFacebookF size={18} /></a>
              <a href="#" aria-label="Instagram"><FaInstagram size={20} /></a>
              <a href="#" aria-label="YouTube"><FaYoutube size={20} /></a>
            </div>
          </div>

          {/* Right Links */}
          <div className="space-y-2 text-sm">
            <p>LATEST NEWS</p>
            <p>PRESS INQUIRIES</p>
            <p>PARTNERS</p>
            <p>CAREER</p>
            <p>CONTACT & RESERVATIONS</p>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 flex flex-col md:flex-row items-center justify-between text-xs text-black text-center space-y-4 md:space-y-0">
          <p>© Nammos World 2025.</p>
          <div className="space-x-6">
            <a href="#">TERMS OF SERVICE</a>
            <a href="#">PRIVACY POLICY</a>
          </div>
          <p className="font-medium">Created by MOBLAC</p>
        </div>
      </footer>
    </div>
  );
}
